var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
        }
      }),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerSeguimientoVacacion"),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-text",
            { staticClass: "p-0" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("span", { staticClass: "material-symbols-outlined" }, [
                      _vm._v("\n            leaderboard\n          ")
                    ]),
                    _vm._v("\n          Reporte de vacaciones\n        ")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "p-0",
                          staticStyle: { "min-width": "100%" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha inicio",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_inicio,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_inicio", $$v)
                                      },
                                      expression: "form.fecha_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", md6: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha fin",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_fin", $$v)
                                      },
                                      expression: "form.fecha_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { staticClass: "py-0", attrs: { md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.unidades_generales,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad general",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_general,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_general",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_general"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { staticClass: "py-0", attrs: { md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.unidades_especificas,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad especifica",
                                      maxlength: "50",
                                      clearable: "",
                                      outline: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_especifica,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_especifica",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_especifica"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Paterno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.paterno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "paterno", $$v)
                                      },
                                      expression: "form.paterno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Materno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.materno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "materno", $$v)
                                      },
                                      expression: "form.materno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Nombres",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.nombres,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombres", $$v)
                                      },
                                      expression: "form.nombres"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Cédula de identidad",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ci,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ci", $$v)
                                      },
                                      expression: "form.ci"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Item",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.item,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "item", $$v)
                                      },
                                      expression: "form.item"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.estados,
                                      "item-value": "id",
                                      "item-text": "descripcion",
                                      label: "Estado",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_estado,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_estado", $$v)
                                      },
                                      expression: "form.id_estado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.entregados,
                                      "item-value": "id",
                                      "item-text": "entregado",
                                      label: "Estado entregado",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.entregado,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "entregado", $$v)
                                      },
                                      expression: "form.entregado"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(31,14,180,0.3)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.obtenerListaFuncionarios()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("\n              Buscar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "rgba(158,11,127,0.6)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.limpiarCampos()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("redo")]),
                              _vm._v("\n              Limpiar\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_funcionarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros de permisos",
                  "disable-initial-sort": true,
                  loading: _vm.loading,
                  "no-results-text": "No se encontraron coincidencias"
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.uni) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nom) +
                              " " +
                              _vm._s(props.item.pat) +
                              " " +
                              _vm._s(props.item.mat) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.cargo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.secuencia) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.descripcion) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_desde
                                  ? _vm
                                      .$moment(props.item.fecha_desde)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_hasta
                                  ? _vm
                                      .$moment(props.item.fecha_hasta)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.total_dias) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.entregado) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#006A8E",
                                  icon: "",
                                  title: "Ver seguimiento",
                                  outline: ""
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verSeguimientoVacacion(
                                      props.item
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("visibility")])],
                              1
                            ),
                            _vm._v(" "),
                            (props.item.id_estado == 65 ||
                              props.item.id_estado == 55 ||
                              props.item.id_estado == 58) &&
                            (!props.item.id_padre_vacacion ||
                              props.item.id_padre_vacacion == null)
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "rgba( 36, 113, 163,0.7)",
                                      icon: "",
                                      title:
                                        "Ver reporte de programación de vacación"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verReporte(props.item, 0)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            (props.item.id_estado == 65 ||
                              props.item.id_estado == 55 ||
                              props.item.id_estado == 58) &&
                            (props.item.id_padre_vacacion ||
                              props.item.id_padre_vacacion != null)
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "rgba( 36, 113, 163,0.7)",
                                      icon: "",
                                      title:
                                        "Ver reporte de programación de vacación"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verReporte(props.item, 1)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.id_estado == 57
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "rgba( 142, 68, 173 ,0.7)",
                                      icon: "",
                                      title:
                                        "Ver reporte de reprogramación de vacación"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verReporte(props.item, 2)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39b9dd10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b9dd10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes/ReporteVacaciones.vue
// module id = null
// module chunks = 